// extracted by mini-css-extract-plugin
export var cartContainer = "_q2-4";
export var gray = "_q2-1";
export var itemContainer = "_q2-2";
export var itemDetails = "_q2-3";
export var strong = "_q2-0";